import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../axiosBaseQuery";


const roleApi = createApi({
    reducerPath: "base/role",
    baseQuery: axiosBaseQuery,
    tagTypes: ["roleList"],
    endpoints: (builder) =>({
        roleFindAll: builder.query<{ data: any[]; pagination: any }, string | void>({
            providesTags: ['roleList'],
            query: (query = '') => ({
                url: "/base/role" + query,
                method: "GET",
            }),
            transformResponse: (response: any) => {
                return {
                    data: response.data,
                    pagination: response?.pagination,
                };
            },
        }),
        roleCreate: builder.mutation({
            invalidatesTags: ['roleList'],
            query: (data)=>({url: "/base/role", method: "POST", data})
        }),
        roleUpdate: builder.mutation({
            invalidatesTags: ['roleList'],
            query: (data)=>({url: "/base/role/"+data.id, method: "PUT", data})
        }),
        roleDelete: builder.mutation({
            invalidatesTags: ['roleList'],
            query: (id)=>({url: "/base/role/"+id, method: "DELETE"})
        }),
    })
})

export const { useRoleFindAllQuery, useRoleCreateMutation, useRoleUpdateMutation, useRoleDeleteMutation } = roleApi;
export {roleApi};
